import styled from 'styled-components';

const PressImagesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  ${({ isDesktop }) => (isDesktop ? 'margin: 0 140px 0 140px' : 'margin: 0 20px 0 20px')};
`;

export default PressImagesContainer;
